export function getParentNode(node, tagName) {
    let parentTagName = node.parentNode?.tagName?.toLowerCase()

    if(parentTagName === undefined) {
        return false
    }

    if(parentTagName !== tagName) {
        return getParentNode(node.parentNode, tagName)
    }

    return node.parentNode
}

/**
 * @param {HTMLElement} element
 * @param {HTMLElement} parentTarget
 * @return {boolean}
 */
export function hasParentElement(element, parentTarget) {
    if (!element.parentElement) {
        return false
    }

    if (element.parentElement !== parentTarget) {
        return hasParentElement(element.parentElement, parentTarget)
    }

    return true
}

/**
 * @param {HTMLElement} element
 * @param {string} tagName
 * @return {HTMLElement|boolean}
 */
export function getParentElement(element, tagName) {
    let parentTagName = element.parentElement?.tagName?.toLowerCase()

    if (!parentTagName) {
        return false
    }

    if (parentTagName !== tagName) {
        return getParentElement(element.parentElement, tagName)
    }

    return element.parentElement
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 * @return {HTMLElement|boolean}
 */
export function getParentClass(element, className) {
    if (!element.parentElement) {
        return false
    }

    if (!element.parentElement.classList.contains(className)) {
        return getParentClass(element.parentElement, className)
    }

    return element.parentElement
}

export function datasetActions(id) {
    let actions = document.getElementById(id)?.dataset?.actions

    return actions ? actions.split(',') : false
}

export function datasetActionsBySelector(selector) {
    let actions = document.querySelector(selector)?.dataset?.actions

    return actions ? actions.split(',') : false
}

export function getElementById(el) {
    if(el instanceof Element) {
        return el
    }

    return document.getElementById(el)
}

export function getBtnSubmit(el) {
    return el.querySelector('button[type="submit"]')
}

export function preventRestorationScroll() {
    waitDOMContentLoaded().then(() => {
        if ('scrollRestoration' in history) {
            history.scrollRestoration = 'manual'
        }

        window.scrollTo(0,0)
    })
}

export function waitDOMContentLoaded() {
    return new Promise((resolve) => {
        if (document.readyState === 'loading') {  // Loading hasn't finished yet
            document.addEventListener('DOMContentLoaded', () => { resolve() });
        } else {  // `DOMContentLoaded` has already fired
            resolve()
        }
    })
}

export function disabledWithPlaceholder(el) {
    if(! el instanceof Element) {
        el = document.querySelector(el)
    }

    if (el.disabled) {
        return
    }

    el.disabled = true

    el.dataset.originalPlaceholder = el.placeholder

    el.placeholder = el.dataset.disabledPlaceholder
}

export function enabledWithPlaceholder(el) {
    if(! el instanceof Element) {
        el = document.querySelector(el)
    }

    if (! el.disabled) {
        return
    }

    el.disabled = false

    el.placeholder = el.dataset.originalPlaceholder
}

export function addBodyCursorGrabbing() {
    document.body.classList.add('cursor-grabbing')
}

export function removeBodyCursorGrabbing() {
    document.body.classList.remove('cursor-grabbing')
}

/**
 * @param {HTMLElement} el
 * @param {boolean} display
 */
export function displayElement(el, display) {
    if (display) {
        el.classList.remove('d-hidden')
        return
    }

    el.classList.add('d-hidden')
}

/**
 * @param {HTMLCollection} htmlCollection
 * @param {(item: HTMLElement) => boolean} callback
 *
 * @return HTMLElement|null
 */
export function htmlCollectionFirst(htmlCollection, callback) {
    let idx = 0
    let length = htmlCollection.length

    while (idx < length) {
        if (callback(htmlCollection[idx])) {
            return htmlCollection[idx]
        }

        ++idx
    }

    return null
}

/**
 * @param {HTMLCollection} htmlCollection
 * @param {(item: HTMLElement) => boolean} callback
 *
 * @return HTMLElement[]
 */
export function htmlCollectionFilter(htmlCollection, callback) {
    let idx = 0
    let length = htmlCollection.length

    const list = []

    while (idx < length) {
        if (callback(htmlCollection[idx])) {
            list.push(htmlCollection[idx])
        }

        ++idx
    }

    return list
}

const btnLoading = {
    start(el) {
        el.disabled = true
        el.querySelector("i")?.classList?.add("d-none")
        el.insertAdjacentHTML('afterbegin', '<i class="fas fa-spinner fa-pulse"></i>')
    },

    finish(el) {
        el.disabled = false
        el.removeChild(el.childNodes[0])
        el.querySelector("i")?.classList?.remove("d-none")
    }
}

export { btnLoading }
